import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import { useTenant } from '../../../../contexts/TenantContext';
import { usePreviewHeader } from '../hooks';
import { formatTimestamp } from '../utils';

const PreviewHeader: React.FC = () => {
  const { isAddEditHost } = useTenant();
  const { modificationTimestamp } = usePreviewHeader();
  const savedOn = formatTimestamp(modificationTimestamp);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 2, md: 4 },
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '@media print': { py: 1 },
      }}
    >
      {/* Left: Logo (Bright only) */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {!isAddEditHost() && (
          <img src="/bright/logo.svg" alt="Bright MLS" style={{ height: 48 }} />
        )}
      </Box>

      {/* Right: Title + timestamp + print */}
      <Box
        sx={{
          textAlign: 'right',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 0.5,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 500, fontStyle: 'italic', color: 'text.primary' }}
        >
          Draft Listing Preview
        </Typography>
        {savedOn && (
          <Typography variant="caption" color="text.secondary">
            Last saved on: {savedOn}
          </Typography>
        )}
        <Button
          variant="outlined"
          size="small"
          startIcon={<PrintIcon />}
          onClick={() => window.print()}
          sx={{ mt: 0.5, '@media print': { display: 'none' } }}
        >
          Print
        </Button>
      </Box>
    </Box>
  );
};

export default React.memo(PreviewHeader);
